/* Cimafer · memória do CEP (UX: reduzir digitação repetida)
   Guarda o último CEP que o cliente calculou (localStorage) e pré-preenche os
   campos de CEP em TODAS as telas — PDP, Sacola (drawer) e página do carrinho.
   Não substitui o autofill do browser (mantemos autocomplete="postal-code");
   apenas lembra o CEP que ELE mesmo usou por aqui. */
(() => {
  const KEY = 'cima:cep';
  // Campos de CEP: .js-zip-input (PDP + drawer via shipping-calculator) e
  // [data-ship-cep] (página do carrinho).
  const SEL = '.js-zip-input, [data-ship-cep]';

  const digits = (s) => (s || '').replace(/\D/g, '').slice(0, 8);
  const fmt = (d) => (d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d);
  const get = () => { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } };
  const save = (d) => { try { if (d.length === 8) localStorage.setItem(KEY, d); } catch (e) { /* noop */ } };

  // Pré-preenche um campo (uma vez, só se estiver vazio).
  const prefill = (inp) => {
    if (!inp || inp.dataset.cimaCep === '1' || (inp.value && inp.value.trim())) return;
    const saved = get();
    if (!saved) return;
    inp.dataset.cimaCep = '1';
    inp.value = fmt(saved);
    // dispara input p/ acionar qualquer formatação da tela (idempotente)
    inp.dispatchEvent(new Event('input', { bubbles: true }));
  };
  const scan = () => { document.querySelectorAll(SEL).forEach(prefill); };

  // Salva o CEP quando o cliente CALCULA (clique no botão ou Enter no campo).
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const btn = t.closest('.cima-frete__btn, [data-ship-calc], shipping-calculator button');
    if (!btn) return;
    const scope = btn.closest('shipping-calculator, .cima-frete, [data-ship]') || document;
    const inp = scope.querySelector(SEL);
    if (inp) save(digits(inp.value));
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches(SEL)) return;
    save(digits(e.target.value));
  }, true);

  // Pré-preenche no load e sempre que o drawer re-renderizar (AJAX de qtd/cupom).
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('dispatch:cart-drawer:refresh', () => setTimeout(scan, 60));
  const drawer = document.getElementById('cart-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(() => scan()).observe(drawer, { childList: true, subtree: true });
  }
})();
